import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createProject } from "../actions/projectActions";
import { PROJECT_CREATE_RESET } from "../constants/projectConstants";

const AddProjectScreen = () => {
  const { developerId, developerName } = useParams(); // <-- read both
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const projectCreate = useSelector((state) => state.projectCreate);
  const { loading, error, success } = projectCreate;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Our createProject expects (developerId, name, description)
    dispatch(createProject(developerId, name, description));
  };

  useEffect(() => {
    if (success) {
      navigate("/admin-dashboard");
      dispatch({ type: PROJECT_CREATE_RESET });
    }
  }, [success, navigate, dispatch]);

  return (
    <div>
      <h2>
        Add New Project for Developer: {developerName} (ID: {developerId})
      </h2>

      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <p>Loading...</p>}

      <form onSubmit={handleSubmit}>
        <div>
          <label>Project Name:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Description:</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

        <button type="submit">Create Project</button>
      </form>
    </div>
  );
};

export default AddProjectScreen;
